import React, { useState, useRef, useEffect, forwardRef } from "react";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";
import "../../../css/theme.css";
import { useSelector } from "react-redux";
import { useDrag, useDrop } from "react-dnd";
import Tippy from "@tippyjs/react";
import {
  Customer,
  Collaborator,
  User,
  Super_Admin,
  Stakeholder,
} from "../../../constant/AuthenticationConstant";
import { reminderTimeDropdownOptions, validateDateWithWorkingHoursTimeZone } from "../../../utils";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import InputField from "../../../component/input-field";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../../component/modal-popup/customeModal";

export const TableRow = ({
  row,
  i,
  moveRow,
  setDraggingState,
  formik,
  isEmbedded,
  activityOptions,
  CustomMenuList,
  departmentOptions,
  isLoading,
  options,
  collabOptions,
  setAssignmentMappingID,
  setToBeDeleted,
  setopenModal,
  isConfigChange,
  tdClass,
  workingHours,
  stakeholderOptions
}) => {
  const dropRef = useRef(null);
  const dragRef = useRef(null);
  const { department_wise_user, collaboratorListByCompany } = useSelector(
    (state) => state.user
  );
  const { configurationSettingMappingData } = useSelector(
    (state) => state.configurationReducer
  );
  const { activityAssignmentData, activityAssignmentDataByConfigurationId } =
    useSelector((state) => state.assignmentReducer);
  const { type } = useSelector((state) => state.auth);

  const index = i;
  // Dropping part
  const [, drop] = useDrop({
    accept: "row",
    hover(item, monitor) {
      if (!dropRef.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }
      // Determine rectangle on screen
      const hoverBoundingRect = dropRef.current.getBoundingClientRect();
      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      // Determine mouse position
      const clientOffset = monitor.getClientOffset();
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      // Time to actually perform the action
      moveRow(dragIndex, hoverIndex);
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex;
    },
  });

  // Dragging Part
  const [{ isDragging }, drag, preview] = useDrag({
    type: "row",
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const opacity = isDragging ? 0.6 : 1;

  preview(drop(dropRef));
  drag(dragRef);

  const overdueCondition = ["completed", "completed with delay", "extension"];
  const getStatusStyles = (status) => {
    status =
      moment().isAfter(
        formik.values.assignmentData[index].estimated_time,
        "date"
      ) &&
      !overdueCondition.includes(formik.values.assignmentData[index].status) &&
      formik.values.assignmentData[index].status !== "in progress"
        ? "overdue"
        : moment().isAfter(
            formik.values.assignmentData[index].estimated_time,
            "date"
          ) &&
          !overdueCondition.includes(
            formik.values.assignmentData[index].status
          ) &&
          formik.values.assignmentData[index].status !== "pending"
        ? "overdue-inprogress"
        : formik.values.assignmentData[index].status;

    switch (status) {
      case "completed":
      case "completed with delay":
        return {
          className:
            "w-4 h-4 border-3 rounded-full border-[--bg-color-500] bg-[--bg-color-500]",
          innerDiv: null,
          tooltipContent: "completed",
        };
      case "pending":
        return {
          className: "w-4 h-4 border-3 rounded-full border-[--bg-color-500]",
          innerDiv: null,
        };
      case "in progress":
        return {
          className: "w-4 h-4 border-3 rounded-full border-[--bg-color-500] relative",
          innerDiv: (
            <div className="absolute top-0 left-0 w-1/2 h-full bg-[--bg-color-500] rounded-l-full border-0"></div>
          ),
        };
      case "overdue":
        return {
          className: "w-4 h-4 border-3 rounded-full border-[#D31313]",
          innerDiv: null,
          tooltipContent: "overdue",
        };
      case "overdue-inprogress":
        return {
          className: "w-4 h-4 border-3 rounded-full border-[#D31313] relative",
          innerDiv: (
            <div className="absolute top-0 left-0 w-1/2 h-full rounded-l-full border-0 bg-[#D31313]"></div>
          ),
          tooltipContent: "overdue-inprogress",
        };
      case "tentative":
        return {
          className: "w-4 h-4 border-3 rounded-full border-[--bg-color-500] border-dotted relative",
          innerDiv: null,
          tooltipContent: "tentative",
        };
      default:
        return {
          className: "w-4 h-4 border-3 rounded-full border-grey-500",
          innerDiv: null,
        };
    }
  };

  const renderStatus = (status) => {
    const { className, innerDiv, tooltipContent } = getStatusStyles(status);

    return status ? (
      <Tippy content={tooltipContent ?? status}>
        <div className={className}>{innerDiv}</div>
      </Tippy>
    ) : (
      <div className={className}>{innerDiv}</div>
    );
  };

  const currentDate = moment();

  // Creating function for default minimum date in estimater date.
  const getMinimumDate = (date) => {
    const isLessThanCurrentDate = moment(date).isBefore(currentDate);
    const isGreaterThanCurrentDate = moment(date).isAfter(currentDate);
    const equalToCurrentDate = moment(date).isSame(currentDate, "day");

    if (isLessThanCurrentDate) {
      return date;
    } else if (isGreaterThanCurrentDate) {
      return new Date();
    } else if (equalToCurrentDate) {
      return new Date();
    }
  };

  // Creating function for ETA
  const addEta = (date, index, previous_date, flag = false) => {
    if (date) {

      // if(flag && workingHours?.is_working_hours){

      //   const day = moment(date).format('dddd').toLowerCase();
      //   let working_hours = JSON.parse(workingHours?.working_hours || '[]');
      //   const workingDay = working_hours.find(item => item.day === day && item.is_active);

      //   if(!workingDay){
      //     swal({
      //       content: (
      //         <CustomeModal
      //           type="warning"
      //           title="Warning!"
      //           content={`${date} is not belong to your company working hours.`}
      //         />
      //       ),
      //       buttons: false,
      //       closeOnClickOutside: false,
      //       closeOnEsc: false,
      //     });
      //   }

      //   const onlyTime = moment(date, 'YYYY-MM-DD HH:mm:ss').format('HH:mm');

      //   const isWithinRange = moment(onlyTime, 'HH:mm').isBetween(
      //     moment(workingDay.start_time, 'HH:mm'),
      //     moment(workingDay.end_time, 'HH:mm'),
      //     undefined,
      //     '[]'
      //   );

      //   if (!isWithinRange) {
      //     swal({
      //       content: (
      //         <CustomeModal
      //           type="warning"
      //           title="Warning!"
      //           content={`Please select time between ${workingDay.start_time} and ${workingDay.end_time}.`}
      //         />
      //       ),
      //       buttons: false,
      //       closeOnClickOutside: false,
      //       closeOnEsc: false,
      //     });
      //   }

      // }
      if(!flag){
        if(workingHours && workingHours?.is_working_hours){
          const todoFind = activityAssignmentData.activity_assignment_mappings.find(item => item.activity_id === formik.values.assignmentData[index].activity_id);
        
          if(todoFind && (todoFind.dept_timzone || todoFind.user_timzone)){
            const timezone = todoFind?.user_timzone ? todoFind.user_timzone : todoFind.dept_timzone;
            if(timezone){
              const calculated_date = validateDateWithWorkingHoursTimeZone(timezone, workingHours, previous_date, date);
              if(calculated_date !== null) {
                date = calculated_date;
              }
            }
          }
        }        
      }

      formik.setFieldValue(
        `assignmentData[${index}].estimated_time`,
        // new Date(eta)
        moment(date).format("YYYY-MM-DD HH:mm")
      );

      if (
        formik.values.assignmentData[index]?.reminder_time &&
        moment(date).isBefore(
          formik.values.assignmentData[index]?.reminder_time
        )
      ) {
        formik.setFieldValue(`assignmentData[${index}].reminder_time`, null);
      }
    } else {
      formik.setFieldValue(`assignmentData[${index}].estimated_time`, null);
      formik.setFieldValue(`assignmentData[${index}].reminder_time`, null);
    }

    for (let i = 0; i < configurationSettingMappingData.length; i++) {
      if (
        configurationSettingMappingData[i].link_activity ===
        formik.values.assignmentData[index].activity_id
      ) {
        const getIndex = formik.values.assignmentData.findIndex(
          (item) =>
            item.activity_id === configurationSettingMappingData[i].activity.id
        );
        let eta = moment(date)
          .add(configurationSettingMappingData[i].duration, "hours")
          // .toDate();
        
        // const todoFind = activityAssignmentData.activity_assignment_mappings.find(item => item.activity_id === formik.values.assignmentData[index].activity_id);
        
        // if(todoFind && (todoFind.dept_timzone || todoFind.user_timzone)){
        //   const timezone = todoFind?.user_timzone ? todoFind.user_timzone : todoFind.dept_timzone;
        //   if(timezone){
        //     const calculated_date = validateDateWithWorkingHoursTimeZone(timezone, workingHours, date, eta);
        //     if(calculated_date !== null) eta = calculated_date;
        //   }
        // }

        // formik.setFieldValue(
        //   `assignmentData[${getIndex}].estimated_time`,
        //   // new Date(eta).toISOString()
        //   moment(eta).format("YYYY-MM-DD HH:mm")
        // );

        addEta(eta, getIndex, date);
      }
    }
  };

  const linkLoopActivityName = (activityId) => {
    if (isConfigChange) {
      const activityName = activityAssignmentDataByConfigurationId?.filter(
        (item) => item.activity_id === activityId
      )[0]?.activity.name;
      return activityName;
    } else {
      const activityName =
        activityAssignmentData?.activity_assignment_mappings?.filter(
          (item) => item.activity_id === activityId
        )[0]?.activity.name;
      return activityName;
    }
  };

  const isMandatory = formik.values.assignmentData[index].is_mandatory;
  const hasLinkActivity = formik.values.assignmentData[index].link_activity;
  const hasLoopActivity = formik.values.assignmentData[index].loop_activity;
  const hasDependentActivity = formik.values.assignmentData[index].dependent_todo;
  

  const departmentId =
    formik.values.assignmentData[index].departmentSelect?.value;

  const filteredCollabOptions = collabOptions?.filter((data) => {
    const user = collaboratorListByCompany?.find(
      (user) => user?.collaborator_id === data?.value
    );
    return user ? user.type === departmentId : false;
  });
  const finalFilteredCollabOptions =
    filteredCollabOptions.length > 0
      ? filteredCollabOptions.filter((data) => {
          const user = collaboratorListByCompany.find(
            (user) => user?.collaborator_id === data?.value
          );
          return user?.type ? user?.type === departmentId : false;
        })
      : [];

  const selectedCustomer = collabOptions?.find((data) => {
    if (activityAssignmentData?.customer_id) {
      return activityAssignmentData.customer_id === data.value;
    }
  });
  const isSelectedCustomer =
    departmentId === Customer && selectedCustomer ? selectedCustomer : false;

  const handleOnDepartmentChange = (newValue) => {
    if(newValue?.type === Stakeholder){
      formik.setFieldValue(`assignmentData[${index}].departmentSelect`, newValue);
      formik.setFieldValue(
        `assignmentData[${index}].stakeholder_category_id`,
        newValue?.value
      ); 
      formik.setFieldValue(`assignmentData[${index}].department_id`, Stakeholder);
    }else{
      formik.setFieldValue(
        `assignmentData[${index}].department_id`,
        newValue?.value
      );
      formik.setFieldValue(`assignmentData[${index}].departmentSelect`, newValue);
      formik.setFieldValue(`assignmentData[${index}].stakeholder_category_id`, "");
    }
    formik.setFieldValue(`assignmentData[${index}].user_id`, "");
    // formik.setFieldValue(`assignmentData[${index}].userSelect`, []);
    formik.setFieldValue(`assignmentData[${index}].collaborator_id`, "");
    if (newValue?.value === Customer && selectedCustomer) {
      formik.setFieldValue(
        `assignmentData[${index}].userSelect`,
        selectedCustomer
      );
      formik.setFieldValue(
        `assignmentData[${index}].collaborator_id`,
        selectedCustomer?.value
      );
    } else if(newValue?.type === Stakeholder){
      const collaborator = activityAssignmentData?.booking_stakeholders?.find(ele => ele.stakeholder_category_id === newValue?.value);
      if(collaborator){
        formik.setFieldValue(`assignmentData[${index}].userSelect`, {
          label: collaborator.collaborator_name,
          value: collaborator.collaborator_id
        });
        formik.setFieldValue(`assignmentData[${index}].collaborator_id`, collaborator.collaborator_id);
      }else{
        formik.setFieldValue(`assignmentData[${index}].userSelect`, "");
      }
    } else {
      formik.setFieldValue(`assignmentData[${index}].userSelect`, []);
    }
  };

  // Function to set reminder date-time on changing Reminder Time Dropdown value
  const setReminderDateTime = (time, index) => {
    const reminderDateTime = moment(
      formik.values.assignmentData[index].estimated_time
    )
      .subtract(time, "hours")
      .format("YYYY-MM-DD HH:mm");
    formik.setFieldValue(
      `assignmentData[${index}].reminder_time`,
      reminderDateTime
    );
  };

  return (
    <tr
      ref={dropRef}
      className={`px-2 py-3 whitespace-nowrap ${formik.values.assignmentData[index].status && "cursor-not-allowed" }`}
      key={index}
      style={{ opacity: `${formik.values.assignmentData[index].status === "tentative" ? "0.7" : opacity }` }}
    >
      <td
        ref={dragRef}
        className={`px-2 py-3 whitespace-nowrap cursor-pointer ${tdClass}`}
        onMouseLeave={(e) => {
          setDraggingState(null);
        }}
      >
        <svg
          class="h-6 w-5 text-gray-300"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="21" y1="10" x2="3" y2="10" />{" "}
          <line x1="21" y1="6" x2="3" y2="6" />{" "}
          <line x1="21" y1="14" x2="3" y2="14" />{" "}
          <line x1="21" y1="18" x2="3" y2="18" />
        </svg>
      </td>
      <td className={`px-2 py-2 whitespace-nowrap ${tdClass}`}>
        <div className="relative">
          <div className="flex items-center justify-center space-x-3 px-0">
            {renderStatus(formik.values.assignmentData[index]?.status)}
          </div>
        </div>
      </td>

      <td className={`px-2 py-2 whitespace-nowrap ${tdClass}`}>
        <div className="relative">
          <p className="text-xs whitespace-nowrap space-x-3">
            <span
              className={`fas fa-asterisk text-sm ${
                !isMandatory
                  ? "pointer-events-none opacity-20"
                  : "text-[--bg-color-500]"
              }`}
            ></span>
            <Tippy
              content={linkLoopActivityName(
                formik.values.assignmentData[index].link_activity
              )}
            >
              <span
                className={`fas fa-link text-sm ${
                  !hasLinkActivity
                    ? "pointer-events-none opacity-20"
                    : "text-[--bg-color-500]"
                }`}
              ></span>
            </Tippy>
            <Tippy
              content={linkLoopActivityName(
                formik.values.assignmentData[index].loop_activity
              )}
            >
              <span
                className={`fas fa-infinity text-sm ${
                  !hasLoopActivity
                    ? "pointer-events-none opacity-20"
                    : "text-[--bg-color-500]"
                }`}
              ></span>
            </Tippy>
            <Tippy
              content={linkLoopActivityName(
                formik.values.assignmentData[index].dependent_todo
              )}
            >
              <span
                className={`fa-regular fa-link-simple text-sm ${
                  !hasDependentActivity
                    ? "pointer-events-none opacity-20"
                    : "text-[--bg-color-500]"
                }`}
              ></span>
            </Tippy>
          </p>
        </div>
      </td>
      <td
        className={`px-2 py-2 whitespace-nowrap ${tdClass} ${
          !isEmbedded ? "" : "w-1/5"
        }`}
      >
        <div className="flex items-center">
          <Select
            options={activityOptions.filter((element) => {
              return !formik.values.assignmentData.some((el) => {
                return el?.activity_id === element?.value;
              });
            })}
            menuPlacement="auto"
            isClearable={true}
            name="ToDoName"
            menuPortalTarget={document.body}
            className={`${!isEmbedded ? "w-48" : "w-60"} unresetText`}
            onChange={(newValue) => {
              formik.setFieldValue(
                `assignmentData[${index}].activity_id`,
                newValue?.value
              );
              formik.setFieldValue(
                `assignmentData[${index}].activitySelect`,
                newValue
              );
            }}
            styles={{
              menuPortal: (base) => ({
                ...base,
                zIndex: 9999,
              }),
            }}
            value={formik.values.assignmentData[index].activitySelect}
            placeholder="Select To Do"
            isDisabled={
              formik.values.assignmentData[index].status === "completed" ||
              formik.values.assignmentData[index].status ===
                "completed with delay" ||
              formik.values.assignmentData[index].status === "in progress" || 
              formik.values.assignmentData[index].status === "tentative"
            }
            components={!isEmbedded ? { MenuList: CustomMenuList } : {}}
          />
        </div>
      </td>

      <td
        className={`px-2 py-2 whitespace-nowrap ${tdClass} ${
          !isEmbedded ? "" : "w-1/5"
        }`}
      >
        <Select
          options={departmentOptions}
          menuPortalTarget={document.body}
          className={`${!isEmbedded ? "w-48" : "w-60"} unresetText`}
          name="TeamName"
          menuPlacement="auto"
          isClearable={true}
          onChange={(newValue) => {
            handleOnDepartmentChange(newValue);
          }}
          styles={{
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999,
            }),
            // groupHeading: (provided) => ({
            //   ...provided,
            //   // fontWeight: 'bold',
            //   // color: '#1e293b',
            //   fontSize: "13px",
            //   // textTransform: "none"
            // }),
          }}
          placeholder="Select Team"
          value={formik.values.assignmentData[index].departmentSelect}
          isDisabled={
            formik.values.assignmentData[index].status === "completed" ||
            formik.values.assignmentData[index].status ===
              "completed with delay" ||
            formik.values.assignmentData[index].status === "in progress" ||
            formik.values.assignmentData[index].activitySelect?.is_immutable || 
            formik.values.assignmentData[index].status === "tentative"
          }
          components={
            !isEmbedded
              ? type === Super_Admin
                ? { MenuList: CustomMenuList }
                : {}
              : {}
          }
        />
      </td>
      <td
        className={`px-2 py-2 whitespace-nowrap ${tdClass} ${
          !isEmbedded ? "" : "w-1/5"
        }`}
      >
        <Select
          isClearable
          isDisabled={
            isLoading ||
            formik.values.assignmentData[index].status === "completed" ||
            formik.values.assignmentData[index].status ===
              "completed with delay" ||
            isSelectedCustomer ||
            formik.values.assignmentData[index].status === "in progress" ||
            formik.values.assignmentData[index].activitySelect?.is_immutable || 
            formik.values.assignmentData[index].status === "tentative" ||
            formik.values.assignmentData[index].stakeholder_category_id
          }
          isLoading={isLoading}
          className={`${!isEmbedded ? "w-48" : "w-60"} unresetText`}
          onChange={(newValue) => {
            if (departmentId === Customer || departmentId === Collaborator) {
              formik.setFieldValue(
                `assignmentData[${index}].collaborator_id`,
                newValue?.value
              );
            } else if(departmentId === Stakeholder){
              formik.setFieldValue(
                `assignmentData[${index}].stakeholder_category_id`,
                newValue?.value
              );
            } else {
              formik.setFieldValue(
                `assignmentData[${index}].user_id`,
                newValue?.value
              );
            }
            formik.setFieldValue(
              `assignmentData[${index}].userSelect`,
              newValue
            );
          }}
          options={
            departmentId === Stakeholder ? stakeholderOptions :
            departmentId === Customer || departmentId === Collaborator
              ? finalFilteredCollabOptions
              : options.filter((data) => {
                  const user = department_wise_user.find(
                    (user) => user?.id === data?.value
                  );
                  return user?.departments
                    ? user?.departments.some(
                        (item) =>
                          item?.id ===
                          formik.values.assignmentData[index].department_id
                      )
                    : false;
                }).length > 0
              ? options.filter((data) => {
                  const user = department_wise_user.find(
                    (user) => user?.id === data?.value
                  );
                  return user?.departments.some((item) => {
                    return item?.id
                      ? item?.id ===
                          formik.values.assignmentData[index].department_id
                      : false;
                  });
                })
              : []
          }
          value={formik.values.assignmentData[index].userSelect}
          placeholder="Select User"
          name={
            departmentId === Collaborator
              ? Collaborator
              : departmentId === Customer
              ? Customer
              : departmentId === Stakeholder
              ? Stakeholder 
              : User
          }
          menuPortalTarget={document.body}
          menuPlacement="auto"
          styles={{
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999,
            }),
          }}
          components={
            !isEmbedded
              ? type === Super_Admin
                ? { MenuList: CustomMenuList }
                : {}
              : {}
          }
        />
      </td>
      <td className={`px-2 py-2 whitespace-nowrap ${tdClass}`}>
        <div className="w-44 relative">
          <Flatpickr
            disabled={
              formik.values.assignmentData[index].status === "completed" ||
              formik.values.assignmentData[index].status ===
                "completed with delay" ||
              formik.values.assignmentData[index].status === "in progress" || 
              formik.values.assignmentData[index].status === "tentative"
            }
            data-enable-time
            options={{
              disableMobile: true,
              enableTime: true,
              altInput: true,
              altFormat: "j M, Y H:i",
              dateFormat: "Y-m-d H:i",
              time_24hr: true,
              minDate: !formik.values.assignmentData[index].estimated_time
                ? new Date()
                : getMinimumDate(
                    formik.values.assignmentData[index].estimated_time
                  ),
            }}
            value={formik.values.assignmentData[index].estimated_time}
            placeholder="Select End Date"
            onChange={(e) => {
              addEta(e[0], index, formik.values.assignmentData[index].estimated_time, true);
            }}
            className={`w-44 text-sm ${
              !isEmbedded
                ? "rounded border-1 border-gray-300 active:border-gray-400 focus:border-gray-400"
                : "rounded-md border-2 border-gray-200 border-r-4 active:border-gray-200 focus:border-gray-200"
            } ${
              formik.values.assignmentData[index].status === "completed" ||
              formik.values.assignmentData[index].status ===
                "completed with delay" ||
              formik.values.assignmentData[index].status === "in progress" || 
              formik.values.assignmentData[index].status === "tentative"
                ? "bg-slate-100 cursor-not-allowed"
                : "cursor-pointer"
            }`}
          />
          {formik.values.assignmentData[index].estimated_time &&
            !(
              formik.values.assignmentData[index].status === "completed" ||
              formik.values.assignmentData[index].status ===
                "completed with delay" ||
              formik.values.assignmentData[index].status === "in progress" || 
              formik.values.assignmentData[index].status === "tentative"
            ) && (
              <button
                type="reset"
                className={
                  "absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-300 hover:text-gray-400"
                }
                onClick={() => {
                  formik.setFieldValue(
                    `assignmentData[${index}].estimated_time`,
                    null
                  );
                  formik.setFieldValue(
                    `assignmentData[${index}].reminder_time`,
                    null
                  );
                }}
              >
                <i className="fas fa-times text-base"></i>
              </button>
            )}
        </div>
      </td>
      <td className={`px-2 py-2 whitespace-nowrap relative ${tdClass}`}>
        <Select
          options={reminderTimeDropdownOptions}
          value={formik.values.assignmentData[index].reminderTimeDropdownVal}
          isClearable
          isDisabled={
            isLoading ||
            formik.values.assignmentData[index].status === "completed" ||
            formik.values.assignmentData[index].status ===
              "completed with delay" ||
            formik.values.assignmentData[index].status === "in progress" ||
            !formik.values.assignmentData[index].estimated_time ||
            formik.values.assignmentData[index].activitySelect?.is_immutable || 
            formik.values.assignmentData[index].status === "tentative"
          }
          onChange={(data) => {
            formik.setFieldValue(
              `assignmentData[${index}].reminderTimeDropdownVal`,
              data
            );
            setReminderDateTime(data?.value, index);
          }}
          isLoading={isLoading}
          className={`${!isEmbedded ? "w-48" : "w-60"} unresetText`}
          placeholder="Select Reminder Time"
          menuPortalTarget={document.body}
          menuPlacement="auto"
          styles={{
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999,
            }),
          }}
        />
      </td>

      <td
        className={`text-center px-2 py-2 whitespace-nowrap text-sm bg-[--bg-color-50] rounded-r-md leading-4 tracking-tight font-semibold
        ${!isEmbedded ? "" : "space-x-1 first:pl-5 last:pr-5"}`}
      >
        <div title="Delete">
          <span
            className={`fa-light fa-trash-can text-base ${
              formik.values.assignmentData[index].status === "completed" ||
              formik.values.assignmentData[index].status ===
                "completed with delay"
                ? "pointer-events-none cursor-not-allowed"
                : "cursor-pointer text-[#eb5757]"
            }`}
            onClick={() => {
              setAssignmentMappingID(row.activity_assignment_mapping_id);
              setopenModal(1);
              setToBeDeleted(i);
            }}
          ></span>
        </div>
      </td>
    </tr>
  );
};
